<div class="formular">
  <form [formGroup]="registerForm" #registerFormEl="ngForm" (ngSubmit)="sendForm()">
    <ng-content></ng-content>
    <div class="wrap">
      <app-google-button [signupButton]="true" [locale]="locale" (googleSignIn)="googleSignup($event)"></app-google-button>
      <div class="or-separator align-center" id="or">
        <p>{{ 'no_survey.or' | translate }}</p>
      </div>

      <div>
        <input formControlName="provider" type="hidden" name="provider" required />
        <input formControlName="uid" type="hidden" name="uid" />
        <div class="ds-form-row" [ngClass]="{ 'has-error': registerFormEl.submitted && emailControl.invalid }">
          <label class="ds-ui-2" for="email">{{ 'no_survey.user.email' | translate }}</label>
          <input
            formControlName="email"
            type="email"
            name="email"
            class="ds-input"
            [placeholder]="'placeholder.email' | translate"
            [ngClass]="{ 'is-invalid': registerFormEl.submitted && emailControl.invalid }"
            id="track_email_input"
            data-cy="input-email"
            required
          />
          <div *ngIf="registerFormEl.submitted && emailControl.invalid" class="ds-input-error">
            <div>{{ 'no_survey.user.wrong_email' | translate }}</div>
          </div>
          <div *ngIf="exists_message" class="ds-input-error">
            <br class="xs-only sm-only" />
            {{ 'no_survey.user.exists_email_app_loc' | translate }}
          </div>
        </div>
      </div>

      <div>
        <div class="ds-form-row input-password" [ngClass]="{ 'has-error': registerFormEl.submitted && isPasswordInvalid }">
          <label class="ds-ui-2" for="password">{{ 'no_survey.user.new_pass' | translate }}</label>
          <div class="input-wrapper">
            <input
              class="ds-input"
              [ngClass]="{ touched: passwordControl.value }"
              (input)="hidePasswordHints = false"
              [type]="showPass ? 'text' : 'password'"
              minlength="12"
              maxlength="128"
              type="password"
              formControlName="password"
              [placeholder]="'placeholder.password' | translate"
              [ngClass]="{ 'is-invalid': registerFormEl.submitted && isPasswordInvalid }"
              id="track_pass_input"
              data-cy="input-password"
              required
            />
            <app-ds-icon
              [name]="showPass ? 'eye-off' : 'eye'"
              color="var(--color-core-neutral-7)"
              size="icon-size-2"
              (click)="passVisibility()"
              id="visibility"
            ></app-ds-icon>
          </div>
        </div>
        <app-register-password-strength
          class="password-hints"
          [dirty]="passwordControl.dirty"
          [password]="passwordControl.value"
          [submitted]="registerFormEl.submitted"
          (isPasswordInvalid)="onIsPasswordInvalid($event)"
          *ngIf="(registerFormEl.submitted && isPasswordInvalid) || !hidePasswordHints"
        >
        </app-register-password-strength>
      </div>

      <div class="form-element newsletter-optin">
        <app-ds-checkbox
          [hasError]="error_message && registerFormEl.submitted"
          [errorMessage]="'no_survey.sorry.p1' | translate"
          (clicked)="newsletterOptin()"
          [checked]="optinControl.value"
        >
          <p class="ds-ui-2">
            <span [innerHTML]="'signup.checkbox.gdpr' | translate"></span>
            <a [href]="getRedirectUrlForPrivacyPolicy()" target="_blank">{{ 'signUp.checkbox.privacyPolicy' | translate }}</a>
          </p>
        </app-ds-checkbox>
      </div>

      <app-ds-button type="submit" width="auto" [isLoading]="loading" data-cy="btn-submit">
        {{ 'no_survey.user.next' | translate }}
      </app-ds-button>
    </div>
    <p class="have-login ds-ui-1">
      {{ 'no_survey.user.have_account' | translate }}
      <a (click)="onShowLogin()">{{ 'no_survey.user.signin' | translate }}</a>
    </p>
  </form>
</div>
